import styled from "styled-components";

// A página é filha de um grid (PageLayout): sem min-width: 0 qualquer conteúdo largo estica a
// coluna 1fr além da tela em vez de rolar dentro do card.
export const PageContainer = styled.div`
  min-width: 0;
  width: 100%;
`;

export const FilterContainer = styled.div`
  padding: 16px;
  border-bottom: 1px solid rgba(118, 127, 141, 0.1);
`;

export const FilterContent = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 16px;
  width: 100%;
  .ant-input-suffix {
    margin-bottom: 6px !important;
  }

  @media (max-width: 700px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const FilterTypeField = styled.div`
  min-width: 100px;
  flex-shrink: 0;

  @media (max-width: 700px) {
    min-width: 0;
    width: 100%;
  }
`;

export const FilterValueField = styled.div`
  min-width: 260px;
  flex-shrink: 0;

  @media (max-width: 700px) {
    min-width: 0;
    width: 100%;
  }
`;

export const AllBodyContainer = styled.div`
  width: 100%;
  height: 100%;

  p {
    color: var(--Content-Neutral, #767f8d);
    font-size: 15px;
    font-weight: 400;
    line-height: 145%;
    letter-spacing: -0.15px;
    margin: 0;
  }
  span {
    color: var(--Content-Neutral-High, #303742);
    text-align: right;
    font-size: 15px;
    font-weight: 600;
    line-height: 145%;
    letter-spacing: -0.15px;
    overflow-wrap: anywhere;
  }
`;

export const BodyTopContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const BodyTopContent = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
`;

export const BodySection = styled.div`
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid rgba(118, 127, 141, 0.1);
`;

export const SectionTitle = styled.p`
  && {
    font-size: 16px;
    color: #6a7181;
    margin-bottom: 12px;
  }
`;

// Respiro interno do card da etapa; o cabeçalho usa o mesmo valor (negativo) para encostar nas bordas
const PATHWAY_CARD_PADDING = "16px";

export const PathwayHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;

  /* ocupa a largura toda do card (anula o padding dele) para a linha encostar nas bordas;
     fechada, anula também o padding de baixo para o título ficar centralizado */
  margin: -${PATHWAY_CARD_PADDING} -${PATHWAY_CARD_PADDING}
    ${({ $isOpen }) => ($isOpen ? "0" : `-${PATHWAY_CARD_PADDING}`)};
  padding: ${PATHWAY_CARD_PADDING};

  /* linha separando o título do conteúdo (só com a etapa aberta) */
  ${({ $isOpen }) => $isOpen && "border-bottom: 1px solid rgba(118, 127, 141, 0.2);"}
`;

// Etapa inteira numa borda só: título (cabeçalho clicável) + motivo de ineficiência + paradas
export const PathwayCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: ${PATHWAY_CARD_PADDING};
  border: 1px solid rgba(118, 127, 141, 0.2);
  border-radius: 8px;
  :not(:last-child) {
    margin-bottom: 12px;
  }
`;

export const PathwayTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  p {
    font-size: 16px;
  }
`;

// Cabeçalho da parada: rótulo pequeno à esquerda (a etapa é o único título) e as tags
// (status e "Atual") coladas na ponta direita
export const StopHeader = styled(PathwayTitle)`
  justify-content: space-between;

  && p {
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #767f8d;
  }
`;

export const StopTags = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const StopCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const EventItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 8px 0;
  border-bottom: 1px dashed rgba(118, 127, 141, 0.15);
  :last-child {
    border-bottom: 0;
  }

  /* o span do AllBodyContainer é feito para valores (à direita, em negrito); aqui é título */
  && span {
    text-align: left;
    font-size: 14px;
    font-weight: 500;
    line-height: 140%;
  }
  small {
    font-size: 13px;
    line-height: 140%;
    color: #767f8d;
  }
`;

export const AttachmentsHint = styled.small`
  display: block;
  margin-top: 4px;
  color: #767f8d;
`;

export const InefficiencyItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 8px 0;
  small {
    color: #767f8d;
  }
`;

export const ReasonTextArea = styled.div`
  margin-top: 12px;
`;
